import React, {useEffect} from 'react';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';

function Notification() {    

    const notificationBucketState =  useSelector(state => state.NotificationBucket);

    if(notificationBucketState.message){

        toast(<><span className="icon notification-icon"><i className="material-icons-outlined">notifications</i></span>{notificationBucketState.message}</>);

    }
    return (
        <>
            <ToastContainer />
        </>
    );
}

  
export default Notification;